import React, { useMemo } from "react";
import "../css/section-three.scss";
import InfoCard from "./info-card";
import CalendarImage from "../img/calendar.png";
import ActiveCommitteesImage from "../img/active-committees.png";
import { Chart } from "../../../_components";

export const SectionThree = ({
  committees,
  patientSafetyData,
  hospitalErrors,
}) => {
  const committeeChartData = useMemo(() => {
    const values = {
      data: [
        {
          name: "درصد تحقق",
          data: [],
        },
      ],
      categories: [],
    };

    if (committees) {
      committees.committees.forEach((item) => {
        values.categories.push(item.committee);
        values.data[0].data.push(item.data.realization_percentage || 0);
      });
    }

    return values;
  }, [committees]);

  const patientSafetyChartData = useMemo(() => {
    const values = {
      data: [
        {
          name: "تعداد",
          data: [],
        },
      ],
      categories: [],
    };

    if (patientSafetyData) {
      patientSafetyData.psvc_per_ward.forEach((item) => {
        values.categories.push(item.ward);
        values.data[0].data.push(item.count || 0);
      });
    }

    return values;
  }, [patientSafetyData]);

  const hospitalErrorsChartData = useMemo(() => {
    const values = {
      data: [
        {
          name: "تعداد",
          data: [],
        },
      ],
      categories: [],
    };

    if (hospitalErrors) {
      hospitalErrors.ward_error_data.forEach((item) => {
        values.categories.push(item.ward);
        values.data[0].data.push(item.count || 0);
      });
    }

    return values;
  }, [hospitalErrors]);

  return (
    <div className="section_3">
      <div className="hospital_committees">
        <p className="title iran-sans_Bold">کمیته های بیمارستان</p>
        <InfoCard title="اطلاعات کلی">
          <div className="hospital_committees_boxes">
            <div className="hospital_committees_box">
              <p className="title">تعداد کل کمیته ها</p>
              <p className="value">{committees?.total_committees}</p>
            </div>
            <div className="hospital_committees_box">
              <p className="title">تعداد جلسات برگزار شده</p>
              <p className="value">{committees?.total_events}</p>
            </div>
          </div>
          <div className="w-100  text-center chart_box">
            <Chart
              data={committeeChartData?.data}
              categories={committeeChartData?.categories}
              chartType="column"
              chartMargin={[60, 50, 100, 60]}
              yAxis={{
                title: { text: "درصد تحقق" },
              }}
              legend={false}
              key="committeeChartData"
            />
          </div>
        </InfoCard>
      </div>
      <div className="hospital_committee_all">
        <p className="title iran-sans_Bold">نمای کلی کمیته های بیمارستان</p>
        <button
          onClick={() =>
            window.open(
              "https://snjob.ir/evaluation_team_profile/#/?to_calender=true",
              "_blank"
            )
          }
          className="get_link_btn"
        >
          مشاهده جزییات کمیته ها
        </button>
        <img
          onClick={() =>
            window.open("https://snjob.ir/evaluation_team_profile/#/", "_blank")
          }
          title="مشاهده"
          src={CalendarImage}
          className="calendar_image pointer"
          alt=""
        />
      </div>
      <div className="active_committees">
        <p className="title iran-sans_Bold">لیست کمیته های فعال بیمارستان</p>
        <img
          className="w-100 pointer"
          title="مشاهده"
          src={ActiveCommitteesImage}
          onClick={() =>
            window.open(
              "https://snjob.ir/evaluation_team_profile/#/?to_committe=true",
              "_blank"
            )
          }
          alt=""
        />
      </div>
      <div className="patient_safety_management">
        <p className="title iran-sans_Bold">واکراند های مدیریتی ایمنی بیمار</p>
        <button
          onClick={() =>
            window.open(
              "https://snjob.ir/management/#/EvaluationErrorManagement/PatientSafetyVisits_manager?to_walkaround=true",
              "_blank"
            )
          }
          className="get_link_btn iran-sans_Bold"
        >
          مشاهده جزییات بازدید های مدیریتی
        </button>
        <InfoCard title="اطلاعات کلی">
          <div className="header_container">
            <div className="info_box">
              <p className="title">تعداد کل بازدید های انجام شده</p>
              <p className="value">{patientSafetyData?.total_count}</p>
            </div>
            <div className="info_box gauge_chart pt-6">
              <Chart
                height={250}
                exporting={{
                  enabled: false,
                }}
                className="gauge-chart-container mt-6"
                pane={{
                  center: ["50%", "80%"],
                  size: "280px",
                  startAngle: -90,
                  endAngle: 90,
                  tickColor: "red",
                  background: {
                    innerRadius: "60%",
                    outerRadius: "100%",
                    shape: "arc",
                  },
                }}
                tooltip={{
                  enabled: false,
                }}
                yAxis={{
                  min: 0,
                  max: 100,
                  stops: [[0, "#d2d"]],
                  minorTickInterval: null,
                  tickAmount: 1,
                  lineWidth: 0,
                  tickWidth: 0,
                  title: {
                    y: -70,
                  },
                  labels: {
                    y: 16,
                  },
                }}
                data={[
                  {
                    name: "نام",
                    data: [patientSafetyData?.realization_percentage || 0],
                  },
                ]}
                chartType={"gauge"}
                key="patientSafetyDataGauge"
              />
              <div className="chart_footer">
                <p>درصد تحقق اقدامات اصلاحی</p>
                <p>{patientSafetyData?.realization_percentage || 0}%</p>
              </div>
            </div>
            <div className="info_box">
              <p className="title">تعداد فعالیت های مصوب</p>
              <p className="value">
                {patientSafetyData?.approved_step_count || 0}
              </p>
            </div>
          </div>
          <div className="body_container">
            <div className="w-100  text-center chart_box">
              <Chart
                data={patientSafetyChartData?.data}
                categories={patientSafetyChartData?.categories}
                chartType="column"
                chartMargin={[60, 50, 100, 60]}
                legend={false}
                key="patientSafetyData"
              />
            </div>
          </div>
        </InfoCard>
      </div>

      <div className="reporting_in_hospitals">
        <p className="title iran-sans_Bold">
          وضعیت گزارش دهی داوطلبانه خطا در بیمارستان
        </p>
        <button
          onClick={() =>
            window.open(
              "https://snjob.ir/management/#/ControllingMedicalErrors/Analysis_reported_errors",
              "_blank"
            )
          }
          className="get_link_btn iran-sans_Bold"
        >
          مشاهده جزییات خطاها
        </button>
        <InfoCard title="اطلاعات کلی">
          <div className="reporting_in_hospitals_header">
            <div className="reporting_in_hospitals_header_item">
              <p className="title">تعداد کل خطاهای گزارش شده</p>
              <p className="value">{hospitalErrors?.total_count}</p>
            </div>
            <div className="reporting_in_hospitals_header_item">
              <p className="title">تعداد موارد خود اظهاری</p>
              <p className="value">{hospitalErrors?.total_self_expression}</p>
            </div>
          </div>
          <div className="body_container">
            <div className="w-100  text-center chart_box">
              <Chart
                data={hospitalErrorsChartData?.data}
                categories={hospitalErrorsChartData?.categories}
                chartType="column"
                chartMargin={[60, 50, 100, 60]}
                legend={false}
                key="hospitalErrorsChartData"
              />
            </div>
          </div>
        </InfoCard>
      </div>
    </div>
  );
};
